<template>
  <div>
    <div class="social-divider">
      <span class="line1"></span>
      <p>{{ $t('auth.or') }}</p>
      <span class="line2"></span>
    </div>
    <div class="social-wrapper">
      <button
        type="button"
        class="custom-btn social facebook-btn"
        @click="facebookLogin"
      >
        <img :src="iconFacebook" alt="Facebook" />
        <span>Facebook</span>
      </button>
      <button
        type="button"
        class="custom-btn social linkedin-btn"
        @click="linkedinLogin"
      >
        <img :src="iconLinkedin" alt="Linkedin" />
        <span>LinkedIn</span>
      </button>
    </div>

    <!-- Loading overlay for OAuth processes -->
    <LoadingOverlay :show="isLoading" />

    <!-- Error modal for API errors -->
    <CustomModal
      :show="dialog.show"
      :title="dialog.title"
      :message="dialog.message"
      @close="dialog.show = false"
    />
  </div>
</template>

<script>
/* eslint-disable */

import iconFacebook from '@/assets/img/iconsNetwork/ico-facebook-auth.png'
import iconLinkedin from '@/assets/img/iconsNetwork/ico-linkedin-auth.png'

// Services import
import socialAuthService from './services/auth/socialAuthService.js'

// Shared components
import LoadingOverlay from './shared/LoadingOverlay.vue'
import CustomModal from './shared/CustomModal.vue'

export default {
  name: 'component-social',

  components: {
    LoadingOverlay,
    CustomModal
  },

  data() {
    return {
      iconFacebook,
      iconLinkedin,
      isLoading: false,
      dialog: {
        show: false,
        title: '',
        message: ''
      }
    }
  },

  // Removed Social mixin - using socialAuthService instead

  beforeMount() {
    const params = this.$route.query
    const code = params.code

    if (localStorage.linkedin_adding_page) {
      return this.$router.replace({ page: 'pages' })
    }

    // LinkedIn OAuth callback
    if (code && typeof code === 'string' && code.trim() !== '') {
      this.isLoading = true
      socialAuthService
        .verifyLinkedin({ code: code.trim() })
        .then(res => {
          this.isLoading = false
          // Emit with data from httpService (not body) and without dry flag to allow redirect
          this.$emit('linkedin-connected', { ...res.data })
        })
        .catch(error => {
          this.isLoading = false
          console.error('LinkedIn OAuth error:', error)
          this.showError(error)
        })
    }
  },

  methods: {
    /**
     * Show error dialog with standardized error handling
     * @param {Object} res - API response object
     */
    showError(res) {
      this.isLoading = false
      this.dialog.title = this.$t('auth.error.title')

      if (!res.data) {
        this.dialog.message = this.$t('auth.error.server_not_responding')
      } else {
        this.dialog.message =
          (res.response && res.response.statusText) ||
          this.$t('auth.error.network_error')
      }

      this.dialog.show = true
    },

    /**
     * Linkedin Login - Auth page display
     */
    linkedinLogin() {
      try {
        if (this.$ga) {
          this.$ga.event('auth', 'connect-linkedin')
        }
      } catch (e) {
        console.warn('Analytics not available:', e)
      }

      const scope = [
        'r_organization_social',
        'w_member_social',
        'w_organization_social',
        'r_basicprofile',
        'r_emailaddress',
        'r_liteprofile',
        'rw_organization_admin'
      ]

      const { VUE_APP_LINKEDIN_APPID, VUE_APP_LINKEDIN_CALLBACK } = process.env

      // Validate required environment variables
      if (!VUE_APP_LINKEDIN_APPID || !VUE_APP_LINKEDIN_CALLBACK) {
        console.error('LinkedIn configuration missing')
        this.showError({ data: null })
        return
      }

      const url = `https://www.linkedin.com/oauth/v2/authorization?response_type=code&client_id=${VUE_APP_LINKEDIN_APPID}&redirect_uri=${encodeURIComponent(
        VUE_APP_LINKEDIN_CALLBACK
      )}&scope=${scope.join('%20')}`
      // window.location.href is correct here - external OAuth redirect to LinkedIn domain
      window.location.href = url
    },

    /**
     * Facebook Login
     */
    facebookLogin() {
      try {
        if (this.$ga) {
          this.$ga.event('auth', 'facebook-twitter')
        }
      } catch (e) {
        console.warn('Analytics not available:', e)
      }

      FB.login(
        response => {
          if (response.status === 'connected') {
            let uid =
              (response.authResponse && response.authResponse.userID) || null
            let accessToken = response.authResponse.accessToken

            // Validate Facebook auth response
            if (!uid || !accessToken) {
              this.showError({ data: null })
              return
            }

            this.isLoading = true
            socialAuthService
              .getFacebookUserInfo(accessToken)
              .then(res => {
                let success = res.success
                if (!success || success !== true) {
                  this.showError(res)
                  return
                }

                let user = res.data

                socialAuthService
                  .getFacebookLongLivedToken(accessToken)
                  .then(res => {
                    let success = res.success
                    if (!success || success !== true) {
                      this.showError(res)
                      return
                    }
                    let body = {
                      id: uid,
                      token: res.data.access_token
                    }
                    localStorage.setItem('facebook', JSON.stringify(body))

                    socialAuthService
                      .getFacebookPages(body.token)
                      .then(res => {
                        let success = res.success
                        if (!success || success !== true) {
                          this.showError(res)
                          return
                        }

                        let facebook = []
                        res.data.data.forEach(page => {
                          let newPage = {}
                          Object.keys(page).forEach(key => {
                            let value = page[key]
                            if (key === 'id') {
                              key = 'network_id'
                            } else if (key === 'picture') {
                              key = 'avatar'
                              value = value.data.url
                            }
                            newPage[key] = value
                          })
                          facebook.push(newPage)
                        })

                        localStorage.setItem(
                          'facebookPages',
                          JSON.stringify(facebook)
                        )
                        this.isLoading = false
                        this.$emit('facebook-connected', body, user)
                      })
                      .catch(error => {
                        this.isLoading = false
                        this.showError({ data: null })
                      })
                  })
                  .catch(error => {
                    this.isLoading = false
                    this.showError({ data: null })
                  })
              })
              .catch(error => {
                this.isLoading = false
                this.showError({ data: null })
              })
          }
        },
        {
          scope: 'public_profile, email',
          return_scopes: true
        }
      )
    },

    /**
     * Facebook Logout
     */
    facebookLogout() {
      FB.getLoginStatus(response => {
        if (response.status === 'connected') {
          FB.logout(() => {
            FB.Auth.setAuthResponse(null, 'unknown')
            localStorage.removeItem('facebook')
            localStorage.removeItem('facebookPages')
          })
        }
      })
    }
  }
}
</script>
